/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AplicativosRouteImport } from './routes/aplicativos'
import { Route as AreaDoClienteRouteImport } from './routes/area-do-cliente'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CamerasRouteImport } from './routes/cameras'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as DownloadsRouteImport } from './routes/downloads'
import { Route as EmpresasRouteImport } from './routes/empresas'
import { Route as HospedagemRouteImport } from './routes/hospedagem'
import { Route as LojasRouteImport } from './routes/lojas'
import { Route as PlanosRouteImport } from './routes/planos'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as TelefoniaRouteImport } from './routes/telefonia'
import { Route as TrabalheConoscoRouteImport } from './routes/trabalhe-conosco'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AplicativosRoute = AplicativosRouteImport.update({
  id: '/aplicativos',
  path: '/aplicativos',
  getParentRoute: () => rootRouteImport,
} as any)
const AreaDoClienteRoute = AreaDoClienteRouteImport.update({
  id: '/area-do-cliente',
  path: '/area-do-cliente',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const CamerasRoute = CamerasRouteImport.update({
  id: '/cameras',
  path: '/cameras',
  getParentRoute: () => rootRouteImport,
} as any)
const ContatoRoute = ContatoRouteImport.update({
  id: '/contato',
  path: '/contato',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsRoute = DownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => rootRouteImport,
} as any)
const EmpresasRoute = EmpresasRouteImport.update({
  id: '/empresas',
  path: '/empresas',
  getParentRoute: () => rootRouteImport,
} as any)
const HospedagemRoute = HospedagemRouteImport.update({
  id: '/hospedagem',
  path: '/hospedagem',
  getParentRoute: () => rootRouteImport,
} as any)
const LojasRoute = LojasRouteImport.update({
  id: '/lojas',
  path: '/lojas',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanosRoute = PlanosRouteImport.update({
  id: '/planos',
  path: '/planos',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
  id: '/politica-de-privacidade',
  path: '/politica-de-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const SobreRoute = SobreRouteImport.update({
  id: '/sobre',
  path: '/sobre',
  getParentRoute: () => rootRouteImport,
} as any)
const TelefoniaRoute = TelefoniaRouteImport.update({
  id: '/telefonia',
  path: '/telefonia',
  getParentRoute: () => rootRouteImport,
} as any)
const TrabalheConoscoRoute = TrabalheConoscoRouteImport.update({
  id: '/trabalhe-conosco',
  path: '/trabalhe-conosco',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aplicativos': typeof AplicativosRoute
  '/area-do-cliente': typeof AreaDoClienteRoute
  '/auth': typeof AuthRoute
  '/blog': typeof BlogRouteWithChildren
  '/cameras': typeof CamerasRoute
  '/contato': typeof ContatoRoute
  '/downloads': typeof DownloadsRoute
  '/empresas': typeof EmpresasRoute
  '/hospedagem': typeof HospedagemRoute
  '/lojas': typeof LojasRoute
  '/planos': typeof PlanosRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/sobre': typeof SobreRoute
  '/telefonia': typeof TelefoniaRoute
  '/trabalhe-conosco': typeof TrabalheConoscoRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog/': typeof BlogIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aplicativos': typeof AplicativosRoute
  '/area-do-cliente': typeof AreaDoClienteRoute
  '/auth': typeof AuthRoute
  '/cameras': typeof CamerasRoute
  '/contato': typeof ContatoRoute
  '/downloads': typeof DownloadsRoute
  '/empresas': typeof EmpresasRoute
  '/hospedagem': typeof HospedagemRoute
  '/lojas': typeof LojasRoute
  '/planos': typeof PlanosRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/sobre': typeof SobreRoute
  '/telefonia': typeof TelefoniaRoute
  '/trabalhe-conosco': typeof TrabalheConoscoRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog': typeof BlogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/aplicativos': typeof AplicativosRoute
  '/area-do-cliente': typeof AreaDoClienteRoute
  '/auth': typeof AuthRoute
  '/blog': typeof BlogRouteWithChildren
  '/cameras': typeof CamerasRoute
  '/contato': typeof ContatoRoute
  '/downloads': typeof DownloadsRoute
  '/empresas': typeof EmpresasRoute
  '/hospedagem': typeof HospedagemRoute
  '/lojas': typeof LojasRoute
  '/planos': typeof PlanosRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/sobre': typeof SobreRoute
  '/telefonia': typeof TelefoniaRoute
  '/trabalhe-conosco': typeof TrabalheConoscoRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog/': typeof BlogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aplicativos'
    | '/area-do-cliente'
    | '/auth'
    | '/blog'
    | '/cameras'
    | '/contato'
    | '/downloads'
    | '/empresas'
    | '/hospedagem'
    | '/lojas'
    | '/planos'
    | '/politica-de-privacidade'
    | '/sobre'
    | '/telefonia'
    | '/trabalhe-conosco'
    | '/admin'
    | '/blog/$slug'
    | '/blog/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aplicativos'
    | '/area-do-cliente'
    | '/auth'
    | '/cameras'
    | '/contato'
    | '/downloads'
    | '/empresas'
    | '/hospedagem'
    | '/lojas'
    | '/planos'
    | '/politica-de-privacidade'
    | '/sobre'
    | '/telefonia'
    | '/trabalhe-conosco'
    | '/admin'
    | '/blog/$slug'
    | '/blog'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/aplicativos'
    | '/area-do-cliente'
    | '/auth'
    | '/blog'
    | '/cameras'
    | '/contato'
    | '/downloads'
    | '/empresas'
    | '/hospedagem'
    | '/lojas'
    | '/planos'
    | '/politica-de-privacidade'
    | '/sobre'
    | '/telefonia'
    | '/trabalhe-conosco'
    | '/_authenticated/admin'
    | '/blog/$slug'
    | '/blog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AplicativosRoute: typeof AplicativosRoute
  AreaDoClienteRoute: typeof AreaDoClienteRoute
  AuthRoute: typeof AuthRoute
  BlogRoute: typeof BlogRouteWithChildren
  CamerasRoute: typeof CamerasRoute
  ContatoRoute: typeof ContatoRoute
  DownloadsRoute: typeof DownloadsRoute
  EmpresasRoute: typeof EmpresasRoute
  HospedagemRoute: typeof HospedagemRoute
  LojasRoute: typeof LojasRoute
  PlanosRoute: typeof PlanosRoute
  PoliticaDePrivacidadeRoute: typeof PoliticaDePrivacidadeRoute
  SobreRoute: typeof SobreRoute
  TelefoniaRoute: typeof TelefoniaRoute
  TrabalheConoscoRoute: typeof TrabalheConoscoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aplicativos': {
      id: '/aplicativos'
      path: '/aplicativos'
      fullPath: '/aplicativos'
      preLoaderRoute: typeof AplicativosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/area-do-cliente': {
      id: '/area-do-cliente'
      path: '/area-do-cliente'
      fullPath: '/area-do-cliente'
      preLoaderRoute: typeof AreaDoClienteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cameras': {
      id: '/cameras'
      path: '/cameras'
      fullPath: '/cameras'
      preLoaderRoute: typeof CamerasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contato': {
      id: '/contato'
      path: '/contato'
      fullPath: '/contato'
      preLoaderRoute: typeof ContatoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloads': {
      id: '/downloads'
      path: '/downloads'
      fullPath: '/downloads'
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/empresas': {
      id: '/empresas'
      path: '/empresas'
      fullPath: '/empresas'
      preLoaderRoute: typeof EmpresasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hospedagem': {
      id: '/hospedagem'
      path: '/hospedagem'
      fullPath: '/hospedagem'
      preLoaderRoute: typeof HospedagemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lojas': {
      id: '/lojas'
      path: '/lojas'
      fullPath: '/lojas'
      preLoaderRoute: typeof LojasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planos': {
      id: '/planos'
      path: '/planos'
      fullPath: '/planos'
      preLoaderRoute: typeof PlanosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-de-privacidade': {
      id: '/politica-de-privacidade'
      path: '/politica-de-privacidade'
      fullPath: '/politica-de-privacidade'
      preLoaderRoute: typeof PoliticaDePrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sobre': {
      id: '/sobre'
      path: '/sobre'
      fullPath: '/sobre'
      preLoaderRoute: typeof SobreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telefonia': {
      id: '/telefonia'
      path: '/telefonia'
      fullPath: '/telefonia'
      preLoaderRoute: typeof TelefoniaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trabalhe-conosco': {
      id: '/trabalhe-conosco'
      path: '/trabalhe-conosco'
      fullPath: '/trabalhe-conosco'
      preLoaderRoute: typeof TrabalheConoscoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AplicativosRoute: AplicativosRoute,
  AreaDoClienteRoute: AreaDoClienteRoute,
  AuthRoute: AuthRoute,
  BlogRoute: BlogRouteWithChildren,
  CamerasRoute: CamerasRoute,
  ContatoRoute: ContatoRoute,
  DownloadsRoute: DownloadsRoute,
  EmpresasRoute: EmpresasRoute,
  HospedagemRoute: HospedagemRoute,
  LojasRoute: LojasRoute,
  PlanosRoute: PlanosRoute,
  PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,
  SobreRoute: SobreRoute,
  TelefoniaRoute: TelefoniaRoute,
  TrabalheConoscoRoute: TrabalheConoscoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
